import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    ListItem,
    ListItemText,
    Typography
} from '@mui/material';

interface DescargarZipDialogProps {
    open: boolean;
    archivosAusentes: string[];
    onConfirmar: () => void;
    onCancelar: () => void;
}

function DescargarZipDialog({
    open,
    archivosAusentes,
    onConfirmar,
    onCancelar
}: DescargarZipDialogProps) {
    return (
        <Dialog open={open} onClose={onCancelar} maxWidth="sm" fullWidth>
            <DialogTitle>Archivos faltantes en el expediente</DialogTitle>
            <DialogContent>
                <Typography variant="body2" gutterBottom>
                    Los siguientes archivos no están disponibles en el expediente:
                </Typography>
                <List dense disablePadding>
                    {archivosAusentes.map((archivo) => (
                        <ListItem key={archivo} disableGutters>
                            <ListItemText
                                primary={archivo}
                                primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                            />
                        </ListItem>
                    ))}
                </List>
                <Typography variant="body2" sx={{ mt: 1 }}>
                    ¿Desea descargar el ZIP con los archivos disponibles?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Box display="flex" gap={2} width="100%" px={1} pb={1}>
                    <Button variant="outlined" fullWidth onClick={onCancelar}>
                        Cancelar
                    </Button>
                    <Button variant="contained" fullWidth onClick={onConfirmar}>
                        Continuar descarga
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export default DescargarZipDialog;
